import React, {useContext, useEffect} from "react";
import DsarRequestDatatable from "@/Components/Datatables/DsarRequestDatatable";
import {Navigate} from 'react-router-dom';
import {AppContext} from '@/Components/Context/AppContext';

import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import '@/Styles/datatables.scss';
import {can} from "@/Util/permissionChecks";

/**
 * Subject Data page
 */
const DsarRequest = () => {

    useEffect(() => {
        document.title = 'DSAR Request' + ' · ' + document.title;
    }, []);
    if (can('access:supervisor')) {
        return (
            <PageLayout>
                <DsarRequestDatatable/>
            </PageLayout>
        );
    } else {
        return <Navigate to="/"/>;
    }

};

export default DsarRequest;
